import { cn } from '@/common/lib/cn/cn'
export const Spinner = ({ className }: { className?: string }) => {
    return <span className={cn('loading loading-spinner loading-xs', className)}></span>
}
